<mat-card class="full-height overflow-auto">
  <mat-card-content class="full-height">
    <article class="full-height">
      <div class="flex-column gap-16 full-height">
        <h4>{{ 'TEXTILE_DATA.YARN_TYPE.YARN_TYPE' | bmsTranslate: {count: 2} }}</h4>
        <div class="flex-row flex-space-between">
          <p *appHasPermission="YARN_EDIT_PERMISSION" class="b1 url" (click)="createYarn()">
            {{ 'GENERAL.ACTIONS.CREATE_OBJECT' | bmsTranslate: {object: 'TEXTILE_DATA.YARN_TYPE.YARN_TYPE' | bmsTranslate: {count: 1} | lowercase} }}
          </p>
          <div class="flex-end-center search-bar-max ml-auto">
            <vdw-filter #filterComponent (filteredTextChanged)="filterYarnTypes($event)"></vdw-filter>
          </div>
        </div>
        <ag-grid-angular #yarnTypesGrid class="ag-theme-vdw" [class.loading]="loadingForTheFirstTime" [gridOptions]="gridOptions"></ag-grid-angular>
      </div>
    </article>
  </mat-card-content>
</mat-card>
